import Vue from 'vue'
import Vuex from 'vuex'

import router from '@/router/index'
import rootState from '../index'
import rootGetters from '../index'

Vue.use(Vuex)

export default {
  namespaced: true,
  rootState,
  rootGetters,
  state: {
    specialRights: [],
    notificationUserList: [],
    //
    request: [],
    emptyStep: {
      requestId: 0,
      data: '',
      status: 0,
      statusInt: 0,
      assignTo: 0,
      requiredTime: 0.25,
      createUser: '',
    },
    stepInfos: [
      { title: 'Erinnerung', color: '#ff5252' },
      { title: 'Antrag erstellt', color: '#428BCA' },
      { title: 'Abgelehnt vor Bewertung', color: '#fb8c00' },
      { title: 'Nummer vergeben', color: '#4caf50' },
      { title: 'Bewertung gespeichert', color: '#2196f3' },
      { title: 'Bewertung', color: '#428BCA' },
      { title: 'Kalkulation', color: '#4caf50' },
      { title: 'Abgelehnt nach Bewertung', color: '#fb8c00' },
      { title: 'Freigabe', color: '#4caf50' },
      { title: 'Bearbeitung gespeichert', color: '#2196f3' },
      { title: 'Bearbeitung', color: '#428BCA' },
      { title: 'Abschluß', color: '#424242' },
    ],
    docuItems: [
      { text: 'CE', width: 100 },
      { text: 'CSA / UL', width: 100 },
      { text: 'EMV', width: 100 },
      { text: 'GA', width: 100 },
      { text: 'MA', width: 100 },
      { text: 'DHR', width: 100 },
      { text: 'Risiko-Akte', width: 100 },
      { text: 'Verifizierung', width: 100 },
      { text: 'Validierung', width: 100 },
      { text: 'Ersatzteilliste', width: 100 },
      { text: 'Verpackung', width: 100 },
      { text: 'Packliste', width: 100 },
      { text: 'Prüfanweisung / -protokoll', width: 232 },
      { text: 'Erzeugnisstandsliste', width: 232 },
      { text: 'Weitere, Software etc.', width: 232 },
    ],
    tableOptions: {
      page: 1,
      itemsPerPage: 15,
      sortBy: ['createDate'],
      sortDesc: [true],
      selectView: 2,
      filter: [''],
      userId: '',
      userRight: 0,
    },
  },
  getters: {
    specialRights: (state) => state.specialRights,
    notificationUserList: (state) => state.notificationUserList,
    //
    request: (state) => state.request,
    docuItems: (state) => state.docuItems,
    tableOptions: (state) => state.tableOptions,
    emptyStep: (state, getters, rootState) => {
      state.emptyStep.createUser = rootState.user.id
      return state.emptyStep
    },
  },
  mutations: {
    setSpecialRights: (state, rights) => (state.specialRights = rights),
    setNotificationUserList: (state, users) =>
      (state.notificationUserList = users),
    setRequest: (state, data) => {
      // sort steps
      data.steps = data.steps.sort((a, b) =>
        a.createDate < b.createDate ? 1 : -1
      )
      // set step title and color for component 'timeline'
      data.steps.forEach((step) => {
        let stepInfo =
          step.data == 'Erinnerung vom CRM-System'
            ? state.stepInfos[0]
            : state.stepInfos[step.statusInt]

        step.title = stepInfo.title
        step.color = stepInfo.color
      })
      // set request current status
      data.status =
        data.steps.reduce(
          (pv, cv) => (pv < cv.statusInt ? cv.statusInt : pv),
          0
        ) || 0
      // set request master
      data.master =
        data.steps.find((step) => step.statusInt == 3)?.assignTo || ''
      // set request close
      data.close = [2, 7, 11].includes(data.steps[0]?.statusInt) ? true : false

      // add serialTmp for changing
      data.changes.forEach((change) => {
        change.serials.forEach((serial) => {
          serial.serialTmp = serial.serialNo
        })
      })

      state.request = data
    },
    setTableOptions: (state, values) => (state.tableOptions = values),
  },
  actions: {
    async getSpecialRights({ commit }) {
      await Vue.prototype.$axios.get('crm/specialrights').then((res) => {
        commit('setSpecialRights', res.data)
      })
    },
    async loadRequest({ commit }, requestId) {
      await Vue.prototype.$axios.get('crm/request/' + requestId).then((res) => {
        if (res.data === false) {
          alert('Vorgang existiert nicht!')
          router.push('/crm/overview')
        } else {
          commit('setRequest', res.data)
        }
      })
    },
    async handleRequest({ dispatch }, step) {
      if (step.statusInt == 1) await dispatch('addRequest', step)
      else await dispatch('changeRequest', step)
      console.log(step)
      await dispatch('sendMail', step)
      await router.push('/crm/overview')
    },
    addRequest({ state }, step) {
      return Vue.prototype.$axios
        .post('crm/request', {
          request: state.request,
          step: step,
        })
        .then((res) => (state.request.id = res.data.requestId))
    },
    changeRequest({ state }, step) {
      return Vue.prototype.$axios.put('crm/request', {
        request: state.request,
        step: step,
      })
    },
    async sendMail({ dispatch, state, rootState, rootGetters }, step) {
      if ([0, 4, 9].includes(step.statusInt)) return

      let msg = ''
      let sendTo = [step.assignTo]

      //  create message
      var rNo = '<b>' + state.request.prNo + ' / ' + state.request.crNo + '</b>'
      var rTitle = '<b>"' + state.request.title + '"</b>'

      switch (step.statusInt) {
        case 0: // Erinnerung
          break
        case 1: // Antrag erstellt
          msg = '<p>Es ist ein neuer Antrag von '
          msg += rootGetters.FULLNAME(state.request.proposer)
          msg += ' erstellt worden.</p>'
          msg += '<p>' + rTitle + '</p>'
          msg +=
            '<p>Bitte Änderungsnummer vergeben und einen Verantwortlichen benennen.</p>'
          break
        case 2: // Abgelehnt vor Bewertung
          msg = '<p>Der von Ihnen erstellte Änderungsantrag ' + rTitle
          msg += ' wurde abgelehnt.</p>'
          if (step.data != '') {
            msg += '<hr><div style="padding: 5px; background-color: #E9E9E9;">'
            msg += step.data + '</div><hr>'
          }
          msg += '<p>Für weitere Informationen wenden Sie sich bitte an: '
          msg += rootState.user.name + '</p>'
          sendTo = [state.request.proposer]
          break
        case 3: // Nummer vergeben
          msg = '<p>Ihnen wurde die Änderung ' + rNo + ' ' + rTitle
          msg += ' zugewiesen.</p>'
          msg += '<p>Bitte die Arbeiten und den Aufwand bewerten.</p>'
          break
        case 4: // gespeichert
          break
        case 5:
        case 6:
          // Kalkulation
          if (step.assignTo == 'Kalkulation') {
            msg = '<p>Ihnen wurde der Antrag ' + rNo + ' ' + rTitle
            msg += ' zur Kalkulation weitergeleitet.</p>'
          }
          // Freigabe
          else if (step.assignTo == 'Freigabe') {
            msg = '<p>Ihnen wurde der Antrag ' + rNo + ' ' + rTitle
            msg += ' zur Freigabe weitergeleitet.</p>'
          }
          // Bewertung
          else {
            msg = '<p>Ihnen wurde der Antrag ' + rNo + ' ' + rTitle
            msg += ' zur Bewertung mit folgendem Kommentar weitergeleitet.</p>'
            msg += '<hr><div style="padding: 5px; background-color: #E9E9E9;">'
            msg += step.data + '</div><hr>'
          }
          break
        case 7: // Abgelehnt nach Bewertung
          msg = '<p>Ihr Antrag Nr: ' + rNo + ' ' + rTitle
          msg += ' wurde mit folgender Bemerkung abgelehnt.</p>'
          if (step.data != '') {
            msg += '<hr><div style="padding: 5px; background-color: #E9E9E9;">'
            msg += step.data + '</div><hr>'
          }
          sendTo = [
            ...new Set(state.request.steps.map((step) => step.createUser)),
          ]
          break
        case 8: // Freigabe
          msg = '<p>Ihr Antrag Nr: ' + rNo + ' ' + rTitle
          msg += ' wurde genehmigt.</p>'
          msg += '<p>Bitte Bearbeitung starten.</p>'
          sendTo.push('thgu')
          break
        case 9: // gespeichert
          break
        case 10: // Bearbeitung
          msg = '<p>Der Antrag Nr: ' + rNo + ' ' + rTitle
          // Bearbeitung weiterleiten
          if (step.assignTo != state.request.master)
            msg += ' wurde Ihnen zur Bearbeitung weitergeleitet.</p>'
          // Bearbeitung an Verantwortlichen zurück
          else
            msg +=
              ' wurde Ihnen zur Bearbeitung / zum Abschließen weitergeleitet.</p>'
          break
        case 11: // Abschluß
          msg = '<p>Der Antrag Nr: ' + rNo + ' ' + rTitle
          msg += ' wurde geschlossen.</p>'
          sendTo = [
            ...new Set(state.request.steps.map((step) => step.createUser)),
          ]
          sendTo = [...new Set([...sendTo, ...state.notificationUserList])]
          break
        default:
          return
      }

      let recipients = await dispatch('getRecipients', sendTo)

      // send mail
      return await Vue.prototype.$axios.post('crm/mail', {
        msg: msg,
        link: 'https://intra.pausch.de/crm/request/' + state.request.id,
        reci: recipients,
        rNo: state.request.prNo,
        // only for maillog
        rId: state.request.id,
        sendFromTo:
          rootGetters.FULLNAME(rootState.user.id) +
          ' => ' +
          Object.values(recipients).join('; '),
      })
    },
    async getRecipients({ state, rootState, rootGetters }, recipients) {
      var to = {}

      for (const reci of recipients) {
        var user = rootState.allUser.find((user) => user.id == reci) || null

        if (user) {
          to[rootGetters.MAIL(user.id)] = rootGetters.FULLNAME(user.id)
        } else {
          let users = []

          if (reci == 'Nummer vergeben') users = state.specialRights.Freigabe
          else if (reci == 'Kalkulation')
            users = state.specialRights.Kalkulation
          else if (reci == 'Freigabe') users = state.specialRights.Gremium

          users.forEach((user) => {
            to[rootGetters.MAIL(user)] = rootGetters.FULLNAME(user)
          })
        }
      }

      return to
    },
  },
  modules: {},
}
